
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.474 6.84a1.12 1.12 0 00-1.095-.576c-.464.044-.86.36-1.009.805-.149.45-.314.833-.51 1.178.048-.438.072-.906.072-1.41A8.67 8.67 0 0011.086.42c-.32-.29-.77-.381-1.174-.239a1.132 1.132 0 00-.75.906 13.303 13.303 0 01-1.525 4.44 7.49 7.49 0 00-.334-1.215 1.148 1.148 0 00-1.084-.748h-.013a1.137 1.137 0 00-1.07.763c-.423 1.197-.781 2.132-1.531 3.257C2.525 9.205 2 10.785 2 12.418c0 4.245 3.453 7.698 7.698 7.698 4.245 0 7.699-3.453 7.699-7.698 0-2.384-.363-4.574-.923-5.579z","fill":"#F0F5FF"}}),_c('path',{attrs:{"d":"M12.652 14.242h.002c-.092-.654-1.245-2.577-2.01-3.78a.77.77 0 00-1.269-.04c-.776 1.028-1.94 2.546-2.22 2.954a3.08 3.08 0 105.497.867z","fill":"#fff"}})])
          )
        }
      }
    